import { IInspection } from 'pages/SchedulerList/components/Inspection/Inspection.types';
import { ImageListType } from 'react-images-uploading';
import InspectionPhotoService from 'services/ApiService/InspectionPhotoService/InspectionPhotoService';
import { useBase64Converter } from './useBase64Converter';

interface IUseInspectionPhotosProps {
  inspection: IInspection;
}

export const useInspectionPhotos = ({ inspection }: IUseInspectionPhotosProps) => {
  const { base64ToFile, cleanBase64Prefix } = useBase64Converter();

  const getTotalPhotosWithOriginUploadKite = (): number => {
    return inspection.photos.filter((photo) => photo.origin === 'UPLOAD_KITE').length;
  };

  const getMaxStepFromPhotos = (): number => {
    const maxStep = inspection.photos.reduce((acc, photo) => {
      if (photo.step && photo.step > acc) return photo.step;
      return acc;
    }, 0);
    return maxStep;
  };

  const preparePhotoForUpload = (imageBase64: string, mimeType: string, fileName: string): ImageListType => {
    const file = base64ToFile(imageBase64, mimeType, fileName);
    const base64Clean = cleanBase64Prefix(imageBase64);

    return [
      {
        file,
        dataURL: base64Clean,
      },
    ];
  };

  const uploadPhoto = async (imageBase64: string, mimeType: string, fileName: string): Promise<void> => {
    const totalPhotosWithOriginUploadKite = getTotalPhotosWithOriginUploadKite();
    const maxStepFromPhotos = getMaxStepFromPhotos();
    const imageList = preparePhotoForUpload(imageBase64, mimeType, fileName);

    await InspectionPhotoService.uploadPhotos(
      inspection.id,
      imageList,
      maxStepFromPhotos,
      totalPhotosWithOriginUploadKite
    );
  };

  return {
    uploadPhoto,
  };
};
